@if(component(); as component) {
  <ng-container *ngComponentOutlet="component; inputs: {
    item: item().config,
    itemFilter: filter(),
    operator: operator(),
    dataService: dataService(),
    queryFilter: queryFilter(),
    }">
  </ng-container>
}
